<template>
    <div class="time-picker-container">
        <input type="hidden" :value="convertedTime" :name="name">
        <div class="time-select">
            <select :disabled="readonly" v-model="hour" class="time-input" ref="hours">
                <option value="__">--</option>
                <option v-for="h in 12" :key="h" :value="padZero(h)">{{ h }}</option>
            </select>
            <span>:</span>
            <select :disabled="readonly" v-model="minute" class="time-input">
                <option value="__">--</option>
                <option v-for="m in optionsMinutes" :key="m" :value="padZero(m-1)">{{ padZero(m-1) }}</option>
            </select>
            <select :disabled="readonly" v-model="period" class="time-input period">
                <option value="AM">AM</option>
                <option value="PM">PM</option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    name: "MTime",
    props:{
        name: {
            type: String,
            required: true
        },
        value: {
            type: String,
            required: false
        },
        readonly: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            hour: '__',
            minute: '__',
            period: 'AM',
            showPicker: false,
        };
    },
    watch: {
        hour() {
            this.emitChange();
        },
        minute() {
            this.emitChange();
        },
        period() {
            this.emitChange();
        },
        value(){
            this.parseTime(this.value)
        }
    },
    mounted() {
        if (this.value){
            this.parseTime(this.value)
        }
    },
    computed: {
        formattedTime() {
            return `${this.padZero(this.hour)}:${this.padZero(this.minute)} ${this.period}`;
        },
        convertedTime() {
            let hour = parseInt(this.hour);
            if (this.period === 'PM' && hour !== 12) {
                hour += 12;
            }
            if (this.period === 'AM' && hour === 12) {
                hour = 0;
            }
            return `${this.padZero(hour)}:${this.padZero(this.minute)}`;
        },
        optionsMinutes(){
            return this.generateOptions()
        }
    },
    methods: {
        generateOptions() {
            const step = 15;
            const max = 60;
            const options = [];
            for (let i = 0; i < max; i += step) {
                options.push(i+1);
            }
            return options;
        },
        padZero(value) {
            return value.toString().padStart(2, '0');
        },
        emitChange() {
            const formatted = this.convertedTime;
            this.$emit('input', formatted);
            this.$emit('change', formatted);
        },
        emitBlur() {
            this.$emit('blur');
        },
        parseTime(time) {
            const [hours, minutes] = time.split(':').map(Number);
            this.period = hours >= 12 ? 'PM' : 'AM';
            this.hour = this.padZero(hours % 12 || 12);
            this.minute = this.padZero(minutes);
            this.emitChange();
        }
    }
};
</script>


<style scoped>
.time-picker-container {
    display: inline-block;
    position: relative;
    background-color: #fff;
    cursor: pointer;
    text-align: center;
    border-bottom: 1px solid;
    margin-top: -4px;
}

.display-time {
    font-size: 14px;
    color: #333;
}

.time-select {
    display: flex;
    position: relative;
    top: 100%;
    left: 0;
    width: 100%;
    padding: 5px;
    background-color: #fff;
    border: none;
    border-radius: 4px;
    z-index: 100;
}

.time-input {
    width: 25px;
    margin-right: 2px;
    font-size: 12px;
    text-align: center;
    border: none;
    border-radius: 4px;
    appearance: none;
    background: white;
}

.time-input.period {
    width: 30px;
}

.time-input::-ms-expand {
    display: none;
}

.time-picker-container:focus {
    outline: none;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}
</style>
